import { DataCloudEventTypeValues } from '~/modules/analytics/datacloudEventTypes/constants';
import { DataCloudEventType, DataCloudIdentityData } from '~/modules/analytics/datacloudEventTypes/datacloudEventType';
import { DataCloudEventData } from '~/modules/services/analyticsService';
import { AnalyticsEventTopic } from '../analyticsHelper';
import { AnalyticsWeightings } from '../analyticsWeightings';
import { normalizeSearchSource } from '../searchSource';

export interface SearchDataCloudAnalyticsEvent {
    interaction: {
        name: string;
        anonymous?: string;
        withResults?: string;
        contextual?: string;
        clientId?: string;
        listingCategoryName?: string;
        eventType: string;
        language?: string;
        outcome?: number;
        userAgent?: string;
        deviceId: string;
        numberOfResults?: number;
        searchQueryUid?: string;
        searchString?: string;
        searchSource?: string;
    };
    user: {
        attributes: DataCloudIdentityData & {
            eventType: string;
            deviceId: string;
        };
    };
}

export class SearchDataCloudEventType extends DataCloudEventType {
    canHandle(event: DataCloudEventData): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_SEARCH_DONE;
    }

    getBody(event: DataCloudEventData): SearchDataCloudAnalyticsEvent {
        const searchContext = event.searchContext;
        const baseEvent = this.baseBody(event);
        const { totalSearchResults, contextual, searchQueryUid, queryText, searchSource } = searchContext || {};
        return {
            interaction: {
                name: 'search Event',
                anonymous: baseEvent.anonymous ? '1' : '0',
                withResults: totalSearchResults && totalSearchResults > 0 ? '1' : '0',
                contextual: contextual ? '1' : '0',
                clientId: baseEvent.clientId,
                listingCategoryName: event.listingCategoryName,
                deviceId: baseEvent.username,
                eventType: DataCloudEventTypeValues.searchEvent,
                language: baseEvent.language,
                outcome: AnalyticsWeightings.searchPoints,
                userAgent: baseEvent.userAgent,
                numberOfResults: totalSearchResults,
                searchQueryUid: searchQueryUid,
                searchString: queryText,
                searchSource: normalizeSearchSource(searchSource),
            },
            user: {
                attributes: {
                    ...baseEvent.userData,
                    eventType: DataCloudEventTypeValues.identity,
                    deviceId: baseEvent.username,
                },
            },
        };
    }
}
